// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-result-container {
  display: flex;
  width: 80%;
  height: 100%;
  justify-content: center;
  align-items: center;
}

header {
  display: flex;
  justify-content: space-between;
}
header forge-icon-button {
  cursor: pointer;
}

.search-summary-card {
  margin: 0 10px 12px;
}
.search-summary-card .search-summary-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}
.search-summary-card .search-summary-title {
  margin: 0;
  line-height: 1.4;
}
.search-summary-card .search-summary-subtitle {
  color: var(--forge-theme-text-medium, rgba(0, 0, 0, 0.6));
  font-weight: 400;
}
.search-summary-card .search-summary-chips {
  margin-top: 12px;
}

.results-body {
  padding: 0 10px;
}

.forge-table {
  overflow-x: auto;
  --forge-scrollbar-height: 10px;
}

.search-results-table {
  display: block;
  border: 1px solid var(--forge-theme-border-color, rgba(0, 0, 0, 0.12));
  border-radius: 8px;
  overflow: hidden;
  --forge-table-cell-padding-vertical: 14px;
  --forge-table-cell-padding-horizontal: 16px;
  --forge-table-row-height: auto;
  --forge-table-head-cell-background: var(--forge-theme-surface-dim, #f5f5f5);
  --forge-table-head-cell-color: var(--forge-theme-text-high, rgba(0, 0, 0, 0.87));
  --forge-table-row-hover-background: var(--forge-theme-primary-a4, rgba(0, 100, 210, 0.06));
}

.header-padding {
  padding: 0 10px;
}

.search-header {
  display: flex;
}
.search-header .search-bar {
  margin-left: 10px;
  width: 100%;
  padding-bottom: 1px;
}

.paginator-content {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}

.filter-drawer {
  --forge-drawer-width: fit-content;
}

@media screen and (max-width: 767px) {
  :host {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    overflow: hidden;
  }
  h1.header-padding {
    flex: 0 0 auto;
    margin: 0;
  }
  .scaffold-container {
    flex: 1 1 auto;
    min-height: 0;
    height: auto;
  }
}
.results-card-list {
  --forge-list-padding: 0;
}

.card-container {
  margin: 12px 16px;
  --forge-card-shape: 10px;
}
.card-container .search-list-item {
  --forge-list-item-height: fit-content;
}

.result-card-button {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  text-align: left;
}

.result-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px 16px;
  width: 100%;
  min-width: 0;
  max-width: 100%;
}
.result-card__title {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.35;
  color: var(--forge-theme-text-high, rgba(0, 0, 0, 0.87));
  max-width: 100%;
}
.result-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
  color: var(--forge-theme-text-medium, rgba(0, 0, 0, 0.6));
  font-size: 0.875rem;
}
.result-card__meta-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  min-width: 0;
}
.result-card__meta-icon {
  --forge-icon-font-size: 18px;
  flex-shrink: 0;
  color: var(--forge-theme-text-medium, rgba(0, 0, 0, 0.6));
}
.result-card__description {
  font-size: 0.875rem;
  line-height: 1.4;
  color: var(--forge-theme-text-medium, rgba(0, 0, 0, 0.6));
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.result-card__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 2px;
}

forge-paginator::part(container) {
  flex-wrap: wrap;
}

@media screen and (max-width: 600px) {
  .drawer-div {
    width: 100vw;
  }
  .drawer-div .filter-drawer {
    --forge-drawer-width: 100vw;
  }
}
.ocr-list-container {
  --forge-list-padding: 0;
  cursor: pointer;
}

.ocr-content-value {
  border-top: 1px solid var(--forge-theme-border-color, #e0e0e0);
  background: var(--forge-theme-surface-dim, rgba(0, 0, 0, 0.02));
}

.ocr-list-item {
  --forge-list-item-height: fit-content;
}

.ocr-snippet-button {
  display: flex;
  align-items: baseline;
  gap: 8px;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  text-align: left;
  padding: 8px 16px;
}
.ocr-snippet-button .ocr-snippet__label {
  flex-shrink: 0;
  font-size: 0.75rem;
  font-weight: bolder;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--forge-theme-primary);
}
.ocr-snippet-button .ocr-snippet__text {
  color: var(--forge-theme-text-medium, rgba(0, 0, 0, 0.6));
  font-size: 0.875rem;
  line-height: 1.4;
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.long-data-styling {
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  overflow: hidden;
  vertical-align: top;
  max-width: 350px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/meeting-manager/search-result/search-result.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AACA;EACI,aAAA;EACA,8BAAA;AAEJ;AADI;EACI,eAAA;AAGR;;AACA;EACI,mBAAA;AAEJ;AAAI;EACI,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;AAER;AACI;EACI,SAAA;EACA,gBAAA;AACR;AAEI;EACI,yDAAA;EACA,gBAAA;AAAR;AAGI;EACI,gBAAA;AADR;;AAKA;EACI,eAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,8BAAA;AAFJ;;AAKA;EACI,cAAA;EACA,sEAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;EACA,2CAAA;EACA,8BAAA;EACA,2EAAA;EACA,gFAAA;EACA,0FAAA;AAFJ;;AAKA;EACI,eAAA;AAFJ;;AAIA;EACI,aAAA;AADJ;AAEI;EACI,iBAAA;EACA,WAAA;EACA,mBAAA;AAAR;;AAGA;EACI,aAAA;EACA,yBAAA;EACA,eAAA;AAAJ;;AAEA;EACI,iCAAA;AACJ;;AAEA;EACI;IACI,aAAA;IACA,sBAAA;IACA,YAAA;IACA,aAAA;IACA,gBAAA;EACN;EAEE;IACI,cAAA;IACA,SAAA;EAAN;EAGE;IACI,cAAA;IACA,aAAA;IACA,YAAA;EADN;AACF;AAIA;EACI,uBAAA;AAFJ;;AAKA;EACI,iBAAA;EACA,wBAAA;AAFJ;AAII;EACI,qCAAA;AAFR;;AAMA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAHJ;AAKI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,wDAAA;EACA,eAAA;AAHR;AAMI;EACI,aAAA;EACA,eAAA;EACA,aAAA;EACA,yDAAA;EACA,mBAAA;AAJR;AAOI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;AALR;AAQI;EACI,4BAAA;EACA,cAAA;EACA,yDAAA;AANR;AASI;EACI,mBAAA;EACA,gBAAA;EACA,yDAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AAPR;AAUI;EACI,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AARR;;AAYA;EACI,eAAA;AATJ;;AAWA;EACI;IACI,YAAA;EARN;EASM;IACI,2BAAA;EAPV;AACF;AAWA;EACI,uBAAA;EACA,eAAA;AATJ;;AAYA;EACI,8DAAA;EACA,+DAAA;AATJ;;AAYA;EACI,qCAAA;AATJ;;AAYA;EACI,aAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AATJ;AAWI;EACI,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iCAAA;AATR;AAYI;EACI,yDAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAVR;;AAcA;EACI,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;AAXJ","sourcesContent":[".search-result-container {\r\n    display: flex;\r\n    width: 80%;\r\n    height: 100%;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\nheader {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    forge-icon-button {\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n.search-summary-card {\r\n    margin: 0 10px 12px;\r\n\r\n    .search-summary-header {\r\n        display: flex;\r\n        align-items: flex-start;\r\n        justify-content: space-between;\r\n        gap: 8px;\r\n    }\r\n\r\n    .search-summary-title {\r\n        margin: 0;\r\n        line-height: 1.4;\r\n    }\r\n\r\n    .search-summary-subtitle {\r\n        color: var(--forge-theme-text-medium, rgba(0, 0, 0, 0.6));\r\n        font-weight: 400;\r\n    }\r\n\r\n    .search-summary-chips {\r\n        margin-top: 12px;\r\n    }\r\n}\r\n\r\n.results-body {\r\n    padding: 0 10px;\r\n}\r\n\r\n.forge-table {\r\n    overflow-x: auto;\r\n    --forge-scrollbar-height: 10px;\r\n}\r\n\r\n.search-results-table {\r\n    display: block;\r\n    border: 1px solid var(--forge-theme-border-color, rgba(0, 0, 0, 0.12));\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    --forge-table-cell-padding-vertical: 14px;\r\n    --forge-table-cell-padding-horizontal: 16px;\r\n    --forge-table-row-height: auto;\r\n    --forge-table-head-cell-background: var(--forge-theme-surface-dim, #f5f5f5);\r\n    --forge-table-head-cell-color: var(--forge-theme-text-high, rgba(0, 0, 0, 0.87));\r\n    --forge-table-row-hover-background: var(--forge-theme-primary-a4, rgba(0, 100, 210, 0.06));\r\n}\r\n\r\n.header-padding {\r\n    padding: 0 10px;\r\n}\r\n.search-header {\r\n    display: flex;\r\n    .search-bar {\r\n        margin-left: 10px;\r\n        width: 100%;\r\n        padding-bottom: 1px;\r\n    }\r\n}\r\n.paginator-content {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    margin-top: 8px;\r\n}\r\n.filter-drawer {\r\n    --forge-drawer-width: fit-content;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n    :host {\r\n        display: flex;\r\n        flex-direction: column;\r\n        height: 100%;\r\n        min-height: 0;\r\n        overflow: hidden;\r\n    }\r\n\r\n    h1.header-padding {\r\n        flex: 0 0 auto;\r\n        margin: 0;\r\n    }\r\n\r\n    .scaffold-container {\r\n        flex: 1 1 auto;\r\n        min-height: 0;\r\n        height: auto;\r\n    }\r\n}\r\n\r\n.results-card-list {\r\n    --forge-list-padding: 0;\r\n}\r\n\r\n.card-container {\r\n    margin: 12px 16px;\r\n    --forge-card-shape: 10px;\r\n\r\n    .search-list-item {\r\n        --forge-list-item-height: fit-content;\r\n    }\r\n}\r\n\r\n.result-card-button {\r\n    width: 100%;\r\n    min-width: 0;\r\n    max-width: 100%;\r\n    text-align: left;\r\n}\r\n\r\n.result-card {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n    padding: 14px 16px;\r\n    width: 100%;\r\n    min-width: 0;\r\n    max-width: 100%;\r\n\r\n    &__title {\r\n        font-size: 1rem;\r\n        font-weight: 600;\r\n        line-height: 1.35;\r\n        color: var(--forge-theme-text-high, rgba(0, 0, 0, 0.87));\r\n        max-width: 100%;\r\n    }\r\n\r\n    &__meta {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        gap: 6px 16px;\r\n        color: var(--forge-theme-text-medium, rgba(0, 0, 0, 0.6));\r\n        font-size: 0.875rem;\r\n    }\r\n\r\n    &__meta-item {\r\n        display: inline-flex;\r\n        align-items: center;\r\n        gap: 6px;\r\n        max-width: 100%;\r\n        min-width: 0;\r\n    }\r\n\r\n    &__meta-icon {\r\n        --forge-icon-font-size: 18px;\r\n        flex-shrink: 0;\r\n        color: var(--forge-theme-text-medium, rgba(0, 0, 0, 0.6));\r\n    }\r\n\r\n    &__description {\r\n        font-size: 0.875rem;\r\n        line-height: 1.4;\r\n        color: var(--forge-theme-text-medium, rgba(0, 0, 0, 0.6));\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        max-width: 100%;\r\n    }\r\n\r\n    &__badges {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        gap: 8px;\r\n        margin-top: 2px;\r\n    }\r\n}\r\n\r\nforge-paginator::part(container) {\r\n    flex-wrap: wrap;\r\n}\r\n@media screen and (max-width: 600px) {\r\n    .drawer-div {\r\n        width: 100vw;\r\n        .filter-drawer {\r\n            --forge-drawer-width: 100vw;\r\n        }\r\n    }\r\n}\r\n\r\n.ocr-list-container {\r\n    --forge-list-padding: 0;\r\n    cursor: pointer;\r\n}\r\n\r\n.ocr-content-value {\r\n    border-top: 1px solid var(--forge-theme-border-color, #e0e0e0);\r\n    background: var(--forge-theme-surface-dim, rgba(0, 0, 0, 0.02));\r\n}\r\n\r\n.ocr-list-item {\r\n    --forge-list-item-height: fit-content;\r\n}\r\n\r\n.ocr-snippet-button {\r\n    display: flex;\r\n    align-items: baseline;\r\n    gap: 8px;\r\n    width: 100%;\r\n    min-width: 0;\r\n    max-width: 100%;\r\n    text-align: left;\r\n    padding: 8px 16px;\r\n\r\n    .ocr-snippet__label {\r\n        flex-shrink: 0;\r\n        font-size: 0.75rem;\r\n        font-weight: bolder;\r\n        text-transform: uppercase;\r\n        letter-spacing: 0.04em;\r\n        color: var(--forge-theme-primary);\r\n    }\r\n\r\n    .ocr-snippet__text {\r\n        color: var(--forge-theme-text-medium, rgba(0, 0, 0, 0.6));\r\n        font-size: 0.875rem;\r\n        line-height: 1.4;\r\n        flex: 1 1 auto;\r\n        min-width: 0;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n    }\r\n}\r\n\r\n.long-data-styling {\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    display: inline-block;\r\n    overflow: hidden;\r\n    vertical-align: top;\r\n    max-width: 350px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
